module.exports = __webpack_public_path__ + "img/culture.6e4a6eaa.png";